import { useTranslation } from '../../i18n'

export function BrowserPrintNotice() {
  const { t } = useTranslation('map')
  return (
    <div className="wh-browser-print-notice">
      {t('serverPrint.browserNotToScale')}
    </div>
  )
}
